import { render, staticRenderFns } from "./wenzhang.vue?vue&type=template&id=23d96258&"
import script from "./wenzhang.vue?vue&type=script&lang=js&"
export * from "./wenzhang.vue?vue&type=script&lang=js&"
import style0 from "./wenzhang.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports